'use client';

import { FullBleedLayout } from '@ui/components/layouts';
import { text } from '@modules/shared-garden/text';

import type { SharedGardenProps } from '@modules/shared-garden/containers/shared_garden_container';
import { PageContentLoading } from '@/src/components/PageContentLoading';

export function SharedGarden({ isLoading, gardenName, summary, grid }: SharedGardenProps) {
  if (isLoading) {
    return <PageContentLoading />;
  }

  if (!gardenName) {
    return null;
  }

  return (
    <FullBleedLayout className="h-screen min-h-screen w-full">
      <div className="flex h-full w-full flex-1 flex-col pt-4">
        <div className="flex shrink-0 flex-col gap-2 px-4 pb-2">
          <div className="flex flex-col gap-1">
            <h1 className="text-foreground text-2xl font-semibold">{gardenName}</h1>
            <p className="text-muted-foreground text-sm">{text.readOnlyHint}</p>
          </div>
          {summary}
        </div>

        <div className="flex w-full flex-1 overflow-hidden px-4 py-4">{grid}</div>
      </div>
    </FullBleedLayout>
  );
}
